import { useEffect, useState } from 'react';

import cts from '_cts';
import apis from '_apis';

/**
 * Get Material details
 */
const useMaterialDetails = (projectId, districtId, matId, lang) => {
  const [details, setDetails] = useState({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getMaterialDetails = async () => {
      try {
        setLoading(true);
        const { data } = await cts('get', apis.materialDetailsApi(projectId, districtId, matId, lang));

        if (
          !data
          && !Object.keys(data.content.response.materialDetails).length) {
          throw new Error('There was an error to get material details.');
        }

        setDetails(data.content.response.materialDetails);

        return undefined;
      } catch (e) {
        setError('Error getting materials');
        return Promise.reject(e.message);
      } finally {
        setError(false);
        setLoading(false);
      }
    };
    getMaterialDetails();
  }, [districtId, lang, matId, projectId]);

  return {
    details,
    error,
    loading
  };
};

export {
  useMaterialDetails as default
};
